import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { LineDashArrayViewComponent } from '../../line-type-item/line-dash-array-view.component';
import { TrackStyles } from '../../../../configuration/model/TrackStyles';
import { Subscription } from 'rxjs';
import { LayerTypeFilter } from '../../../../configuration/model/LayerTypeFilter';
import { MatDialog } from '@angular/material/dialog';
import { ConfigurationService } from '../../../../configuration/configuration.service';
import { RouteStatusConfig, RouteStatusConfigComponent } from '../route-status-config/route-status-config.component';
import { SettingsService } from '../../../../configuration/settings.service';

@Component({
  selector: 'app-route-status-legend',
  imports: [MatIconButton, MatTooltip, MatIcon, LineDashArrayViewComponent],
  templateUrl: './route-status-legend.component.html',
  styleUrl: './route-status-legend.component.scss',
})
export class RouteStatusLegendComponent implements OnInit, OnDestroy {

  defaultTrackStyles: TrackStyles;
  defaultStylesSubscription: Subscription;
  defaultLegendSettings: LayerTypeFilter;

  userTrackStyles: TrackStyles;
  userStylesSubscription: Subscription;
  userLegendSettings: LayerTypeFilter;

  constructor(
    public readonly dialog: MatDialog,
    private readonly configurationService: ConfigurationService,
    private readonly settingsService: SettingsService,
  ) {}

  ngOnInit() {
    this.defaultStylesSubscription = this.configurationService.trackStyles$.subscribe(trackStyles => {
      this.defaultTrackStyles = trackStyles;
      this.defaultLegendSettings = LayerTypeFilter.routeStatusLayerTypeFilter(trackStyles);
    });
    this.userStylesSubscription = this.configurationService.userTrackStyles$.subscribe(trackStyles => {
      this.userTrackStyles = trackStyles;
      this.userLegendSettings = LayerTypeFilter.routeStatusLayerTypeFilter(trackStyles);
    });
  }

  ngOnDestroy() {
    this.userStylesSubscription?.unsubscribe();
  }

  openConfiguration() {
    const defaultConfigCopy = JSON.parse(JSON.stringify(this.defaultLegendSettings));
    const userConfigCopy = JSON.parse(JSON.stringify(this.userLegendSettings));
    const data = {
      defaultLegendSettings: defaultConfigCopy,
      legendSettings: userConfigCopy,
    } as RouteStatusConfig;

    const dialogRef = this.dialog.open(RouteStatusConfigComponent, {
      maxWidth: '80vw',
      maxHeight: '85vh',
      width: '500px',
      height: '510px',
      data: Object.assign({}, data),
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined && result) {
        const settings = result as RouteStatusConfig;

        const notDone = settings.legendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_NOT_DONE);
        const defaultNotDone = this.defaultLegendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_NOT_DONE);
        if (notDone && defaultNotDone) {
          if (notDone.color === defaultNotDone.color && notDone.dashArray === defaultNotDone.dashArray) {
            this.settingsService.setStringValue(SettingsService.ROUTE_STATUS_STYLE_NOT_DONE, null);
          } else {
            this.userTrackStyles.routeStatusNotDone.color = notDone.color;
            this.userTrackStyles.routeStatusNotDone.dasharray = notDone.dashArray;
            this.settingsService.setStringValue(
              SettingsService.ROUTE_STATUS_STYLE_NOT_DONE,
              JSON.stringify(this.userTrackStyles.routeStatusNotDone)
            );
          }
        }

        const level1 = settings.legendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_LEVEL1);
        const defaultLevel1 = this.defaultLegendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_LEVEL1);
        if (level1 && defaultLevel1) {
          if (level1.color === defaultLevel1.color && level1.dashArray === defaultLevel1.dashArray) {
            this.settingsService.setStringValue(SettingsService.ROUTE_STATUS_STYLE_1, null);
          } else {
            this.userTrackStyles.routeStatusLevel1.color = level1.color;
            this.userTrackStyles.routeStatusLevel1.dasharray = level1.dashArray;
            this.settingsService.setStringValue(
              SettingsService.ROUTE_STATUS_STYLE_1,
              JSON.stringify(this.userTrackStyles.routeStatusLevel1)
            );
          }
        }

        const level2 = settings.legendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_LEVEL2);
        const defaultLevel2 = this.defaultLegendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_LEVEL2);
        if (level2 && defaultLevel2) {
          if (level2.color === defaultLevel2.color && level2.dashArray === defaultLevel2.dashArray) {
            this.settingsService.setStringValue(SettingsService.ROUTE_STATUS_STYLE_2, null);
          } else {
            this.userTrackStyles.routeStatusLevel2.color = level2.color;
            this.userTrackStyles.routeStatusLevel2.dasharray = level2.dashArray;
            this.settingsService.setStringValue(
              SettingsService.ROUTE_STATUS_STYLE_2,
              JSON.stringify(this.userTrackStyles.routeStatusLevel2)
            );
          }
        }

        const level3 = settings.legendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_LEVEL3);
        const defaultLevel3 = this.defaultLegendSettings.measurementUnits.find(i => i.number === RouteStatusConfigComponent.LEGEND_LEVEL3);
        if (level3 && defaultLevel3) {
          if (level3.color === defaultLevel3.color && level3.dashArray === defaultLevel3.dashArray) {
            this.settingsService.setStringValue(SettingsService.ROUTE_STATUS_STYLE_3, null);
          } else {
            this.userTrackStyles.routeStatusLevel3.color = level3.color;
            this.userTrackStyles.routeStatusLevel3.dasharray = level3.dashArray;
            this.settingsService.setStringValue(
              SettingsService.ROUTE_STATUS_STYLE_3,
              JSON.stringify(this.userTrackStyles.routeStatusLevel3)
            );
          }
        }

        this.configurationService.refreshUserTrackStyles();
      }
    });
  }
}
